import React from 'react';
import PendingClientsTableRow from './PendingClientsTableRow';
import styled from 'styled-components';
import H1 from 'components/Primatives/H1';

const RowWrapper = styled.div`
    padding: 3%;
`

class PendingClientsTable extends React.Component{
    render(){
        const { pendingAccounts } = this.props;
        return(
            <RowWrapper>
                <H1 altDark>Pending account activation</H1>
                { pendingAccounts ?Object.keys(pendingAccounts).map( (pendingAccount, index) => {
                    return (
                        <PendingClientsTableRow 
                            {...pendingAccounts[pendingAccount]} 
                            key={`pendingClient${index}`}
                            index={index}
                        />
                    )
                }) : null}
            </RowWrapper>
        )
    }
}

export default PendingClientsTable;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/PendingClientsTable.jsx